
<div class="custom-slider">
  <ngx-slider
    [(value)]="control.value.min"
    [(highValue)]="control.value.max"
    [options]="options"  >
  </ngx-slider>
</div>  
  <!-- <p>Rango seleccionado: {{ control.value.min }} - {{ control.value.max }}</p> -->
